// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-select + .float-label {
	top: 16px;
}

.float-group .ant-input:focus ~ .float-label {
	top: -10px;
	height: 15px;
	color: var(--dg-orange-color);
	background-color: var(--dg-input-bg);
	padding: 0.1em 0.6em;
	font-size: 0.8rem;
	border-radius: 0.25em;
}

.ant-input-number-focused ~ .float-label {
	top: -10px;
	height: 15px;
	color: var(--dg-orange-color);
	background-color: var(--dg-input-bg);
	padding: 0.1em 0.6em;
	font-size: 0.8rem;
	border-radius: 0.25em;
}

.ant-select-focused ~ .float-label {
	top: -10px;
	height: 15px;
	color: var(--dg-orange-color);
	background-color: var(--dg-input-bg);
	padding: 0.1em 0.6em;
	font-size: 0.8rem;
	border-radius: 0.25em;
}

.ant-input-affix-wrapper-focused ~ .float-label {
	top: -10px;
	height: 15px;
	color: var(--dg-orange-color);
	background-color: var(--dg-input-bg);
	padding: 0.1em 0.6em;
	font-size: 0.8rem;
	border-radius: 0.25em;
}

.ant-input.ant-input-disabled ~ .float-label,
.ant-input-affix-wrapper-disabled ~ .float-label,
.ant-input-number-disabled ~ .float-label {
	color: var(--dg-disabled-color-light);
}

.ant-input.ant-input-disabled ~ .float-label.active-float-label,
.ant-select-disabled ~ .float-label.active-float-label,
.ant-input-affix-wrapper-disabled ~ .float-label.active-float-label,
.ant-input-number-disabled ~ .float-label.active-float-label {
	color: var(--dg-disabled-color-light);
	background-color: var(--dg-input-label-bg-disable);
}

.float-group {
	position: relative;
	width: 100%;
}

.float-label {
	position: absolute;
	z-index: 10;
	top: 14px;
	font-size: 1rem;
	color: var(--dg-primary-color);
	pointer-events: none;
	padding: 0 4px;
	transition: all 200ms ease-in-out;
}

.active-float-label {
	top: -10px !important;
	height: 15px;
	color: var(--dg-orange-color);
	background-color: var(--dg-input-bg);
	padding: 0.1em 0.6em;
	font-size: 0.8rem;
	border-radius: 0.25em;
}
`, "",{"version":3,"sources":["webpack://./src/styles/UI/Input/inputLabel.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,6BAA6B;CAC7B,oCAAoC;CACpC,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,6BAA6B;CAC7B,oCAAoC;CACpC,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,6BAA6B;CAC7B,oCAAoC;CACpC,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,6BAA6B;CAC7B,oCAAoC;CACpC,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;;;CAGC,qCAAqC;AACtC;;AAEA;;;;CAIC,qCAAqC;CACrC,kDAAkD;AACnD;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,8BAA8B;CAC9B,oBAAoB;CACpB,cAAc;CACd,iCAAiC;AAClC;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;CAC7B,oCAAoC;CACpC,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;AACtB","sourcesContent":[".ant-select + .float-label {\n\ttop: 16px;\n}\n\n.float-group .ant-input:focus ~ .float-label {\n\ttop: -10px;\n\theight: 15px;\n\tcolor: var(--dg-orange-color);\n\tbackground-color: var(--dg-input-bg);\n\tpadding: 0.1em 0.6em;\n\tfont-size: 0.8rem;\n\tborder-radius: 0.25em;\n}\n\n.ant-input-number-focused ~ .float-label {\n\ttop: -10px;\n\theight: 15px;\n\tcolor: var(--dg-orange-color);\n\tbackground-color: var(--dg-input-bg);\n\tpadding: 0.1em 0.6em;\n\tfont-size: 0.8rem;\n\tborder-radius: 0.25em;\n}\n\n.ant-select-focused ~ .float-label {\n\ttop: -10px;\n\theight: 15px;\n\tcolor: var(--dg-orange-color);\n\tbackground-color: var(--dg-input-bg);\n\tpadding: 0.1em 0.6em;\n\tfont-size: 0.8rem;\n\tborder-radius: 0.25em;\n}\n\n.ant-input-affix-wrapper-focused ~ .float-label {\n\ttop: -10px;\n\theight: 15px;\n\tcolor: var(--dg-orange-color);\n\tbackground-color: var(--dg-input-bg);\n\tpadding: 0.1em 0.6em;\n\tfont-size: 0.8rem;\n\tborder-radius: 0.25em;\n}\n\n.ant-input.ant-input-disabled ~ .float-label,\n.ant-input-affix-wrapper-disabled ~ .float-label,\n.ant-input-number-disabled ~ .float-label {\n\tcolor: var(--dg-disabled-color-light);\n}\n\n.ant-input.ant-input-disabled ~ .float-label.active-float-label,\n.ant-select-disabled ~ .float-label.active-float-label,\n.ant-input-affix-wrapper-disabled ~ .float-label.active-float-label,\n.ant-input-number-disabled ~ .float-label.active-float-label {\n\tcolor: var(--dg-disabled-color-light);\n\tbackground-color: var(--dg-input-label-bg-disable);\n}\n\n.float-group {\n\tposition: relative;\n\twidth: 100%;\n}\n\n.float-label {\n\tposition: absolute;\n\tz-index: 10;\n\ttop: 14px;\n\tfont-size: 1rem;\n\tcolor: var(--dg-primary-color);\n\tpointer-events: none;\n\tpadding: 0 4px;\n\ttransition: all 200ms ease-in-out;\n}\n\n.active-float-label {\n\ttop: -10px !important;\n\theight: 15px;\n\tcolor: var(--dg-orange-color);\n\tbackground-color: var(--dg-input-bg);\n\tpadding: 0.1em 0.6em;\n\tfont-size: 0.8rem;\n\tborder-radius: 0.25em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
